import { computed, signal } from "@preact/signals-react";
import { userTemplates } from "../Common/Store/CommonSignals";

export const skip = signal(0);
export const take = signal(4);
export const buttonCount = signal(5);
export const type = signal("numeric");
export const info = signal(true);
export const pageSizes = signal(true);
export const previousNext = signal(true);
export const responsive = signal(true);
export const search = signal("");

export const pageState = computed(() => {
  return {
    skip: skip.value,
    take: take.value,
    buttonCount: buttonCount.value,
    type: type.value,
    info: info.value,
    pageSizes: pageSizes.value,
    previousNext: previousNext.value,
    responsive: responsive.value,
  };
});

export const filteredTemplates = computed(() => {
  const searchLower = search.value.toLowerCase();
  return (
    userTemplates.value?.filter((template) => {
      // Check all template values
      const hasMatchInValues = Object.values(template).some((value) =>
        value?.toString().toLowerCase().includes(searchLower)
      );
      // Check tags
      const tags = template.properties?.Tags || [];
      const hasMatchInTags = tags.some((tag) => tag?.toLowerCase().includes(searchLower));
      return hasMatchInValues || hasMatchInTags;
    }) || []
  );
});
